import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonEnterSite: {
    marginTop: 29,
    marginRight: 29,
    alignSelf: "flex-end",
  },
  textEnterSite: {
    fontSize: 25,
    fontFamily: "Prompt",
    color: "#B9B9B9",
  },
  viewLogo: {
    marginTop: 100,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  imgLogo: {
    width: 145,
    height: 139,
    marginHorizontal: 10,
  },
  textTitle: {
    fontSize: 30,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    textAlign: "center",
  },
  viewLogin: {
    width: 461,
    height: 473,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    marginTop: 53,
    paddingVertical: 20,
  },
  InputLogin: {
    width: 367,
    height: 70,
    borderRadius: 8,
    backgroundColor: "#D0E3F9",
    color: "#717171",
    fontFamily: "Prompt",
    paddingHorizontal: 22,
    alignSelf: "center",
    marginTop: 30,
  },
  buttonRemember: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 47,
    marginTop: 30,
  },
  viewRemember: {
    width: 22,
    height: 23,
    borderWidth: 1,
    borderColor: "#707070",
    borderRadius: 7,
  },
  textRemember: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#717171",
    marginLeft: 10,
  },
  buttonLogin: {
    width: 279,
    height: 56,
    backgroundColor: "#173B64",
    borderWidth: 1,
    borderColor: "#173B64",
    justifyContent: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 30,
  },
  textLogin: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  TextForgotPassword: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#717171",
    textAlign: "center",
    marginTop: 5,
  },
});
export const stylesResponsive = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonEnterSite: {
    marginTop: 29,
    marginRight: 29,
    alignSelf: "flex-end",
  },
  textEnterSite: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#B9B9B9",
  },
  viewLogo: {
    marginTop: 50,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  imgLogo: {
    width: 106,
    height: 100,

    marginHorizontal: 10,
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    textAlign: "center",
  },
  viewLogin: {
    width: width * 0.8,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    marginTop: 30,
    paddingVertical: 20,
  },
  InputLogin: {
    width: width * 0.7,
    height: 50,
    borderRadius: 8,
    backgroundColor: "#D0E3F9",
    fontSize: 12,
    color: "#717171",
    fontFamily: "Prompt",
    paddingHorizontal: 22,
    alignSelf: "center",
    marginTop: 30,
  },
  buttonRemember: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 20,
    marginTop: 15,
  },
  viewRemember: {
    width: 22,
    height: 23,
    borderWidth: 1,
    borderColor: "#707070",
    borderRadius: 7,
  },
  textRemember: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#717171",
    marginLeft: 10,
  },
  buttonLogin: {
    width: width * 0.7,
    height: 50,
    backgroundColor: "#173B64",
    borderWidth: 1,
    borderColor: "#173B64",
    justifyContent: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 30,
  },
  textLogin: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  TextForgotPassword: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#717171",
    textAlign: "center",
    marginTop: 5,
  },
});
